module.exports = __webpack_public_path__ + "media/bootstrap-icons/hourglass-bottom-f4d82249.svg";